import { NavLink, useLocation } from "react-router"

const TELAS = [
    { para: "/visao", rotulo: "Visão da folha" },
    { para: "/repasse", rotulo: "Repasse" },
]

// O link do e-mail abre uma das duas telas, mas o RH que recebeu um costuma querer a outra. O token
// vive na sessão da aba, então trocar de tela não pede link novo.
//
// A query string vai junto: a competência (?r=) é o que o link do e-mail apontou, e ir à Visão e
// voltar não pode trocar a guia do mês por outra.
export const Navegacao = () => {
    const { search } = useLocation()

    return (
        <nav aria-label="Telas do portal" className="mb-6 flex justify-center">
            <ul className="flex gap-1 rounded-full border border-line bg-card p-1 text-sm">
                {TELAS.map((tela) => (
                    <li key={tela.para}>
                        <NavLink
                            to={{ pathname: tela.para, search }}
                            className={({ isActive }) =>
                                isActive
                                    ? "block rounded-full bg-brand px-4 py-1.5 font-semibold text-brand-ink"
                                    : "block rounded-full px-4 py-1.5 font-medium text-soft transition-colors hover:text-ink"
                            }
                        >
                            {tela.rotulo}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    )
}
